import { MopedCoverage } from "Store/interfaces/products/coverage";

export const MOPED_DEFAULT_DEDUCTIBLE = "4000";

export const getDeductible = (coverage: MopedCoverage): string | undefined => {
  if (coverage === MopedCoverage.MOPED_DRIVER_AND_PASSENGER_ACCIDENT) {
    return "Ingen";
  }
  return MOPED_DEFAULT_DEDUCTIBLE;
};
